import React, { useState, useEffect, useRef } from 'react';
import { Box, Button, Typography } from '@mui/material';

interface BarcodeScannerProps {
  onScan: (barcode: string) => void;
}

const BarcodeScanner: React.FC<BarcodeScannerProps> = ({ onScan }) => {
  const [barcode, setBarcode] = useState<string>('');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    // Focus the input when component mounts
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    // Enter key submits the barcode
    if (e.key === 'Enter' && barcode.trim() !== '') {
      onScan(barcode.trim());
      setBarcode('');
    }
  };

  const handleSubmit = () => {
    if (barcode.trim() !== '') {
      onScan(barcode.trim());
      setBarcode('');
    }
  };

  return (
    <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
      <Typography variant="body1" gutterBottom>
        قم بمسح الباركود أو إدخاله يدويًا
      </Typography>
      
      <Box sx={{ display: 'flex', width: '100%', gap: 1 }}>
        <input
          ref={inputRef}
          type="text"
          value={barcode}
          onChange={(e) => setBarcode(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="أدخل الباركود"
          style={{
            padding: '10px',
            fontSize: '16px',
            flex: 1,
            borderRadius: '4px',
            border: '1px solid #ccc'
          }}
          autoFocus
        />
        
        <Button variant="contained" onClick={handleSubmit}>
          إدخال
        </Button>
      </Box>
    </Box>
  );
};

export default BarcodeScanner;